'use strict';

import jQuery from 'jquery';

export default SearchForm;

const SEARCH_PANEL_FORM_COMPONENT_ATTR = 'data-search-panel-form';
const SEARCH_PANEL_FORM_COMPONENT_SELECTOR = '[' + SEARCH_PANEL_FORM_COMPONENT_ATTR + ']';
const SEARCH_PANEL_FORM_BOX = '[data-search-panel-form-box]';
const SEARCH_PANEL_FORM_INPUT_NAME = '[data-search-panel-form-input-name]';
const SEARCH_PANEL_FORM_INPUT_RADIUS = '[data-search-panel-form-input-radius]';
const SEARCH_PANEL_FORM_INPUT_INVENTORY_TYPE = '[data-search-panel-form-input-inventory-type]';
const SEARCH_PANEL_FORM_INPUT_ID = '[data-search-panel-form-input-id]';
const SEARCH_PANEL_FORM_INPUT_TYPE = '[data-search-panel-form-input-type]';
const SEARCH_PANEL_FORM_SUBMIT = '[data-search-panel-form-submit]';
const SEARCH_PANEL_FORM_DOWNLOAD_PDF = '[data-search-panel-form-download-pdf]';
const SEARCH_PANEL_FORM_SUGGESTIONS = '[data-search-panel-form-suggestions]';

const EVENT_SEARCH_PANEL_FORM_DATA_LOADED = 'event-search-panel-form-data-loaded';

const IS_SHOWING_RESULTS_CLASS = 'show-results';
const IS_LOADING_CLASS = 'is-loading';

const EVENT_SEARCH_MAP_NOTIFICATION = 'event-search-map-notification';
const EVENT_SEARCH_PANEL_CLOSE = 'events-search-panel-close';

const $window = jQuery(window);

let selectedEntryIndex = -1;

class SearchForm {

    constructor(element) {
        const component = this;

        component.$element = jQuery(element);
        component.$box = component.$element.find(SEARCH_PANEL_FORM_BOX);
        component.$inputName = component.$element.find(SEARCH_PANEL_FORM_INPUT_NAME);
        component.$inputRadius = component.$element.find(SEARCH_PANEL_FORM_INPUT_RADIUS);
        component.$inventoryType = component.$element.find(SEARCH_PANEL_FORM_INPUT_INVENTORY_TYPE);
        component.$inputID = component.$element.find(SEARCH_PANEL_FORM_INPUT_ID);
        component.$inputType = component.$element.find(SEARCH_PANEL_FORM_INPUT_TYPE);
        component.$submit = component.$element.find(SEARCH_PANEL_FORM_SUBMIT);
        component.$downloadPDF = component.$element.find(SEARCH_PANEL_FORM_DOWNLOAD_PDF);
        component.$suggestions = component.$element.find(SEARCH_PANEL_FORM_SUGGESTIONS);

        component.selectables= [];

        component.disableFormFields(true);

        component.bindEventListeners();
    }

    bindEventListeners() {
        const component = this;

        component.$inputName.keydown(event => {
            if (((event.keyCode == 37 || event.keyCode == 39) && selectedEntryIndex > -1) || event.keyCode == 38 || event.keyCode == 40 || event.keyCode == 13 || event.keyCode == 9) {
                return;
            }

            if (component.$inputName.val().length >= 2) {
                component.getSuggests();
            }
        });

        component.$inputName.keydown(event => {
            if (event.keyCode != 37 && event.keyCode != 38 && event.keyCode != 39 && event.keyCode != 40 && event.keyCode != 13) {
                return;
            }

            if (event.keyCode == 38) {
                selectedEntryIndex--;
            }

            else if (event.keyCode == 40) {
                selectedEntryIndex++;
            }

            else if (event.keyCode == 13) {
                event.preventDefault();

                if (selectedEntryIndex != -1) {
                    let selectedResult = component.$suggestions.find('.search-panel-form__suggestions-item.active');

                    component.$inputName.val(selectedResult.text());
                    component.$inputID.val(selectedResult.data('id'));
                    component.$inputType.val(selectedResult.data('type'));

                    component.setRadiusOptions();
                    component.disableFormFields(false);

                    component.resetSuggests();
                } else {
                    if (component.$inputID.val() != '' && component.$inputType.val() != '') {
                        component.performSearch();
                    }
                }
            }

            if (component.selectables.length > 0 && selectedEntryIndex > -1) {
                selectedEntryIndex = selectedEntryIndex % component.selectables.length;
                component.selectables.removeClass('active');

                let selected = jQuery(component.selectables[selectedEntryIndex]);
                selected.addClass('active');
            }
        });

        component.$submit.on('click', (event) => {
            event.preventDefault();

            component.performSearch();
        });
    }

    getSuggests() {
        const component = this;

        jQuery.ajax({
            url: 'https://api.pdok.nl/bzk/locatieserver/search/v3_1/suggest',
            data: {
                q: component.$inputName.val()
            }
        })

        .then(response => {
            if (!response.response.docs.length) {
                throw Error('Unexpected return');
            }

            return response;
        })

        .then(response => {
            if (response.response.docs.length > 0) {
                component.response = response.response.docs
            }

            component.populateSuggestsBox();
        })

        .catch(error => {
            console.log(error);
        })
    }

    populateSuggestsBox() {
        const component = this;

        component.resetSuggests();

        component.$box.addClass(IS_SHOWING_RESULTS_CLASS);

        component.$suggestions.removeClass('is-hidden');

        component.response.forEach(result => {
            let resultItem = jQuery(`<li class="search-panel-form__box-suggestions-item">${result.weergavenaam}</li>`);

            resultItem.data('id', result.id);
            resultItem.data('type', result.type);

            resultItem.on('click', (event) => {
                component.$inputName.val(result.weergavenaam);
                component.$inputID.val(result.id);
                component.$inputType.val(result.type);

                component.setRadiusOptions();
                component.disableFormFields(false);

                component.resetSuggests();
            })

            component.$suggestions.append(resultItem);
        });

        component.selectables = component.$suggestions.find('.search-panel-form__box-suggestions-item');
    }

    performSearch() {
        const component = this;

        component.$inputName.prop('disabled', true);

        component.disableFormFields(true);

        component.$submit.addClass(IS_LOADING_CLASS);

        jQuery.ajax({
            url: base_url + '/api/get/inventarisaties/zoeken',
            data: {
                name: component.$inputName.val(),
                radius: component.$inputRadius.val(),
                inventory: component.$inventoryType.filter(':checked').val(),
                id: component.$inputID.val(),
                type: component.$inputType.val(),
            },
            headers: {
                'Authorization': 'Bearer ' + token,
            }
        })

        .then(response => {
            if (!response.layers.length) {
                throw Error('Unexpected return');
            }

            return response;
        })

        .then(response => {
            $window.trigger(EVENT_SEARCH_PANEL_CLOSE);
            $window.trigger(EVENT_SEARCH_PANEL_FORM_DATA_LOADED, response);

            component.$inputName.prop('disabled', false);
            component.disableFormFields(false);

            component.$submit.removeClass(IS_LOADING_CLASS);
        })

        .catch(error => {
            $window.trigger(EVENT_SEARCH_MAP_NOTIFICATION, {
                type: 'search-map__notification--warning',
                message: '<strong>Opmerking</strong> Uw zoekopdracht heeft geen resultaten binnen het werkgebied opgeleverd. Probeer het opnieuw.',
                visibleDuration: 5000
            });

            component.$inputName.prop('disabled', false);
            component.disableFormFields(false);

            component.$submit.removeClass(IS_LOADING_CLASS);
        })
    }

    resetSuggests() {
        const component = this;

        component.$box.removeClass(IS_SHOWING_RESULTS_CLASS);

        component.$suggestions.html('');
        component.$suggestions.addClass('is-hidden');

        selectedEntryIndex = -1;
    }

    disableFormFields(bool) {
        const component = this;

        component.$inputRadius.prop('disabled', bool);
        component.$submit.prop('disabled', bool);
        component.$downloadPDF.prop('disabled', bool);
    }

    setRadiusOptions() {
        const component = this;

        if (component.$inputType.val() == 'woonplaats' || component.$inputType.val() == 'gemeente') {
            let radius_array = [0, 250, 500, 1000, 2000, 5000];

            component.$inputRadius.children().remove();

            radius_array.forEach(radius => {
                component.$inputRadius.append(`<option value="${radius}">${radius / 1000} km</option>`);
            });
        } else {
            let radius_array = [250, 500, 1000, 2000, 5000];

            component.$inputRadius.children().remove();

            radius_array.forEach(radius => {
                component.$inputRadius.append(`<option value="${radius}">${radius / 1000} km</option>`);
            });
        }
    }

}

jQuery(SEARCH_PANEL_FORM_COMPONENT_SELECTOR).each((index, element) => new SearchForm(element));
